import { v4 as uuid } from 'uuid';

import { INVENTARIO_CARGA } from './types';

import { changeLoader } from './loader';
import { setAlert } from './alert';

import { obtenerListadoCompletoInventario, ajustarInventario } from './inventarioCargaService';

const mapearPendienteAProducto = (pendiente) => ({
    id_producto: pendiente.id_producto || '',
    nombre: pendiente.nombre,
    codigo: pendiente.codigo,
    descripcion: pendiente.descripcion,
    proveedores: pendiente.proveedores,
    inventarios: pendiente.inventarios
});

export const fetchListadoCompleto = () => async (dispatch) => {
    try {
        await dispatch({ type: INVENTARIO_CARGA.LISTADO_CARGANDO });
        await dispatch(changeLoader(true));

        const productos = await obtenerListadoCompletoInventario();

        await dispatch({
            type: INVENTARIO_CARGA.LISTADO_CARGADO,
            payload: productos
        });
    } catch (error) {
        const msg = error?.response?.data?.msg || 'Error al obtener el listado completo de inventario';

        await dispatch({
            type: INVENTARIO_CARGA.LISTADO_ERROR,
            payload: msg
        });

        dispatch(setAlert(msg, 'danger'));
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const guardarProducto = (tempId) => async (dispatch, getState) => {
    const pendiente = getState()?.inventarioCarga?.pendingChanges?.byId?.[tempId];

    if (!pendiente) {
        return false;
    }

    try {
        await dispatch({ type: INVENTARIO_CARGA.GUARDANDO });
        await dispatch(changeLoader(true));

        const respuesta = await ajustarInventario([mapearPendienteAProducto(pendiente)]);

        await dispatch({ type: INVENTARIO_CARGA.GUARDADO_OK });
        await dispatch({ type: INVENTARIO_CARGA.PENDIENTE_QUITAR, payload: tempId });
        await dispatch(fetchListadoCompleto());

        dispatch(setAlert(respuesta?.msg || 'Producto guardado correctamente', 'success'));
        return true;
    } catch (error) {
        const msg = error?.response?.data?.msg || 'Error al guardar el producto';

        await dispatch({
            type: INVENTARIO_CARGA.GUARDADO_ERROR,
            payload: msg
        });

        dispatch(setAlert(msg, 'danger'));
        return false;
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const guardarTodosPendientes = () => async (dispatch, getState) => {
    const pendingChanges = getState()?.inventarioCarga?.pendingChanges || { byId: {}, allIds: [] };

    const productos = pendingChanges.allIds.map((tempId) => mapearPendienteAProducto(pendingChanges.byId[tempId]));

    if (productos.length === 0) {
        return false;
    }

    try {
        await dispatch({ type: INVENTARIO_CARGA.GUARDANDO });
        await dispatch(changeLoader(true));

        const respuesta = await ajustarInventario(productos);

        await dispatch({ type: INVENTARIO_CARGA.GUARDADO_OK });
        await dispatch({ type: INVENTARIO_CARGA.PENDIENTES_LIMPIAR });
        await dispatch(fetchListadoCompleto());

        dispatch(setAlert(respuesta?.msg || 'Inventario guardado correctamente', 'success'));
        return true;
    } catch (error) {
        const msg = error?.response?.data?.msg || 'No se pudo guardar el lote de productos. Ningún producto fue guardado; revisa e intenta de nuevo.';

        await dispatch({
            type: INVENTARIO_CARGA.GUARDADO_ERROR,
            payload: msg
        });

        dispatch(setAlert(msg, 'danger'));
        return false;
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const agregarPendiente = (cambio) => (dispatch) => {
    const tempId = uuid();

    dispatch({
        type: INVENTARIO_CARGA.PENDIENTE_AGREGAR,
        payload: {
            tempId,
            esNuevo: !!cambio.esNuevo,
            id_producto: cambio.id_producto || null,
            nombre: cambio.nombre ?? '',
            codigo: cambio.codigo ?? '',
            descripcion: cambio.descripcion ?? '',
            proveedores: cambio.proveedores || [],
            inventarios: cambio.inventarios || []
        }
    });

    return tempId;
};

export const actualizarPendiente = (tempId, cambios) => (dispatch) => {
    dispatch({
        type: INVENTARIO_CARGA.PENDIENTE_ACTUALIZAR,
        payload: { tempId, cambios }
    });
};

export const quitarPendiente = (tempId) => (dispatch) => {
    dispatch({
        type: INVENTARIO_CARGA.PENDIENTE_QUITAR,
        payload: tempId
    });
};

export const limpiarPendientes = () => (dispatch) => {
    dispatch({ type: INVENTARIO_CARGA.PENDIENTES_LIMPIAR });
};
